import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatDate, formatEUR, DENONCIATION_STATUSES } from "@/lib/api";
import { PageHeader, SelectField, EmptyState } from "@/components/ui-kit";
import StatusBadge from "@/components/StatusBadge";
import { Ban } from "lucide-react";

export default function Denonciations() {
  const [items, setItems] = useState([]);
  const [statutFilter, setStatutFilter] = useState("a_traiter");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/dossiers").then((r) => {
      const filtered = statutFilter ? r.data.filter((d) => d.denonciation_statut === statutFilter) : r.data;
      setItems(filtered);
    }).finally(() => setLoading(false));
  }, [statutFilter]);

  return (
    <div className="p-8" data-testid="denonciations-page">
      <PageHeader title="Dénonciations" subtitle="Demandes à traiter" />

      <div className="bg-white rounded-sm border border-slate-200 mb-6 p-4 max-w-xs">
        <SelectField testid="denonc-filter" label="Filtrer par statut" value={statutFilter} onChange={(e) => setStatutFilter(e.target.value)}
          options={[{ value: "", label: "Toutes" }, ...DENONCIATION_STATUSES]} />
      </div>

      <div className="bg-white rounded-sm border border-slate-200 overflow-hidden">
        {loading ? <div className="p-10 text-center text-slate-500">Chargement…</div> :
          items.length === 0 ? <EmptyState icon={Ban} title="Aucune dénonciation" description="Ajustez les filtres pour voir plus de résultats." /> :
          <table className="w-full text-sm">
            <thead className="bg-slate-50">
              <tr>
                <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Client</th>
                <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Promoteur</th>
                <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Programme / Lot</th>
                <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Statut</th>
                <th className="text-left px-4 py-3 font-semibold uppercase text-xs">Date</th>
                <th className="text-right px-4 py-3 font-semibold uppercase text-xs">Prix</th>
              </tr>
            </thead>
            <tbody>
              {items.map((d) => (
                <tr key={d.id} className="border-t border-slate-100 hover:bg-slate-50">
                  <td className="px-4 py-3"><Link to={`/dossiers/${d.id}`} className="font-semibold text-[#111111] hover:text-[#B8873A]">{d.client_prenom} {d.client_nom}</Link></td>
                  <td className="px-4 py-3">{d.promoteur || "—"}</td>
                  <td className="px-4 py-3">{d.programme || "—"} <span className="text-xs text-slate-500">Lot {d.lot}</span></td>
                  <td className="px-4 py-3"><StatusBadge value={d.denonciation_statut} kind="denonciation" /></td>
                  <td className="px-4 py-3">{formatDate(d.denonciation_date)}</td>
                  <td className="px-4 py-3 text-right font-medium">{formatEUR(d.prix)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        }
      </div>
    </div>
  );
}
